module.exports = __webpack_public_path__ + "img/5.a57d6bd0.jpg";